import Loading from 'vue-loading-overlay'
import axios from 'axios'
import * as config from '@/config.json'

export default {
  name: 'BotTalk',
  components: {
    Loading
  },
  data: () => {
    return {
      isLoading: false,
      speechId: null,
      selectedOptionCompany: null,
      optionsCompany: [],
      selectedOption: null,
      options: [],
      selectedNotificationType: null,
      optionsNotificationType: [
        { value: 1, text: 'Fala imediata' },
        { value: 2, text: 'Anúncio' }
      ],
      botTalk: '',
      botTalkDescription: '',
      setVolume: false,
      volumeLevel: 5,
      speechDelay: 1
    }
  },

  methods: {
    redirect() {
      const ref = localStorage.getItem('redirectBot') ? localStorage.getItem('redirectBot') : 'home'

      localStorage.removeItem('redirectBot')
      this.$router.push(ref)
    },

    focus(id) {
      document.getElementById(id).focus()
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async getCompanies() {
      const url = `${config.default.urlBase}/companies/user`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsCompany = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: item.name
              }
            })
          )

          if (this.optionsCompany.length == 1) {
            this.selectedOptionCompany = this.optionsCompany[0].value
            this.getSpeechs()
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        this.optionsCompany = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSpeechs() {
      const url = `${config.default.urlBase}/speechs/types`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.options = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: item.description
              }
            })
          )

          if (this.options.length == 1) {
            this.selectedOption = this.options[0].value
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        this.options = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar os tipos de fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async buildDataCreate(description, text, companyId, typeId, notificationType, setVolume, volumeLevel, speechDelay, isEditing = false) {
      const data = {
        description,
        text,
        companyId,
        typeId,
        notificationType,
        setVolume,
        volumeLevel: parseInt(volumeLevel),
        speechDelay: parseInt(speechDelay)
      }

      // Se for edição, incluir o ID no payload
      if (isEditing && this.speechId) {
        data.id = this.speechId
      }

      return data
    },

    loadSpeechData(speechData) {
      // Preencher os campos com os dados da fala
      this.speechId = speechData.id
      this.selectedOptionCompany = speechData.companyId
      this.selectedOption = speechData.typeId
      this.selectedNotificationType = speechData.notificationType
      this.botTalkDescription = speechData.description
      this.botTalk = speechData.text
      this.setVolume = speechData.setVolume || false
      this.volumeLevel = speechData.volumeLevel || 5
      this.speechDelay = speechData.speechDelay || 1
    },

    async createSpeech() {
      // Validação dos campos obrigatórios
      if (!this.selectedOptionCompany) {
        await this.$alert('Por favor, selecione uma empresa!', 'Atenção', 'warning')
        return
      }

      if (!this.selectedOption) {
        await this.$alert('Por favor, selecione o tipo da fala!', 'Atenção', 'warning')
        return
      }

      if (!this.selectedNotificationType) {
        await this.$alert('Por favor, selecione o tipo de notificação!', 'Atenção', 'warning')
        return
      }

      if (!this.botTalkDescription || this.botTalkDescription.trim() === '') {
        await this.$alert('Por favor, digite uma descrição para a fala!', 'Atenção', 'warning')
        return
      }

      if (!this.botTalk || this.botTalk.trim() === '') {
        await this.$alert('Por favor, digite a fala do totem!', 'Atenção', 'warning')
        return
      }

      this.isLoading = true

      const isEditing = !!this.speechId
      const url = `${config.default.urlBase}/companies/speech`

      const data = await this.buildDataCreate(
        this.botTalkDescription,
        this.botTalk,
        this.selectedOptionCompany,
        this.selectedOption,
        this.selectedNotificationType,
        this.setVolume,
        this.volumeLevel,
        this.speechDelay,
        isEditing
      )

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          const actionText = isEditing ? 'atualizada' : 'cadastrada'
          const res = await this.$swal({
            title: 'Sucesso',
            text: `Fala do totem ${actionText}! ${!isEditing ? 'Deseja ir para a tela de vínculo?' : 'Deseja voltar para a consulta?'}`,
            icon: 'success',
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonColor: '#303030',
            cancelButtonColor: '#fe5c3a',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
          })

          if (res.value) {
            if (isEditing) {
              this.$router.push('/bot-speechs')
            } else {
              this.$router.push('/bot-bound')
            }
          }

          if (!isEditing) {
            this.selectedOption = null
            this.selectedNotificationType = null
            this.botTalkDescription = ''
            this.botTalk = ''
            this.setVolume = false
            this.volumeLevel = 5
            this.speechDelay = 1
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao cadastrar a fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')

    // Verificar se há dados da fala via router params para edição
    if (this.$route.params.speechData) {
      this.loadSpeechData(this.$route.params.speechData)
    }

    await this.getCompanies()
    await this.getSpeechs()

    this.isLoading = false
  }
}
